import { Box, useTheme } from "@mui/material";
import { Outlet } from "react-router-dom";
import LeftSidebar from "./LeftSidebar";

const CommonSidebar = ({ tabs }) => {
  const theme = useTheme();
  return (
    <Box sx={{ display: "flex", minHeight: "100vh" }}>
      <LeftSidebar tabs={tabs} />
      <Box sx={{ flex: 1, backgroundColor: theme.palette.background.pageBackground, minWidth: 0 }}>
        <Box sx={{ minWidth: 0 }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default CommonSidebar;
